(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/dashboard/pendingCommands/pendingCommandsWidget.tpl.html',
    '<div class="row" style="padding: 2.5px;"><div ng-if="isDataAvailable"><div class="row" style="padding: 2.5px;"><div class="col-sm-4 col-md-4 col-xs-4"><div jqx-delete-directive="pendingCommandComboBox" type="comboBox"><jqx-combo-box id="pendingCommandComboBox" focus-blur="" ng-model="pendingCommandState" jqx-settings="pendingCommandComboBoxSettings" clear-inpu="" ng-create="dataLoadingFinished"></jqx-combo-box></div></div></div><div class="row" style="padding: 2.5px;"><div class="col-sm-12 col-md-12 col-xs-12"><div jqx-delete-directive="{{overviewGridPrefix}}pendingCommandsList" type="grid"><jqx-grid id="{{overviewGridPrefix}}pendingCommandsList" jqx-settings="pendingCommandsListGridSettings" jqx-create="dataLoadingFinished"></jqx-grid></div></div></div></div><div ng-show="!isDataAvailable"><no-authorize></no-authorize></div></div>');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/pendingCommands/pendingCommandsWidget.tpl.js